.countryCodeSelect {
  font-size: 18px;
  max-height: 50px;
  z-index: 1;
  position: relative;
  box-sizing: border-box;
  font-weight: 500;

  &.disableBackgroundColor {
    background-color: unset;
  }

  @include themify($themes) {
    background-color: themed("neutral-tertiary");
    color: themed("main-primary");
    border-left: solid 1px themed("neutral-secondary");
    border-top: solid 1px themed("neutral-secondary");
    border-bottom: solid 1px themed("neutral-secondary");
    border-right: solid 1px themed("neutral-secondary");

    @include dark-mode() {
      border-right-color: themed("main-secondary");
    }
  }

  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
  padding-left: 8px;
  .selectContainer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 50px;
    display: flex;
    align-items: center;
    padding-bottom: 4px;
  }

  .arrowIcon {
    height: 21px;
    display: flex;
    align-items: center;
    .arrow {
      transition: transform 0.25s ease-in-out;
      height: 12px;
      &.rotateArrow {
        transform: rotate(-180deg);
      }
    }
  }

  .optionsWrapper {
    position: absolute;
    z-index: 1;
    overflow: hidden;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    left: 0px;
    top: calc(100% + 12px);
    width: 335px;
    @include themify($themes) {
      border: solid 1px themed("neutral-secondary");
    }
  }

  .optionsContainer {
    padding: 12px 0;
    overflow: auto;
    display: flex;
    max-height: 300px;
    word-break: break-word;
    flex-direction: column;
    row-gap: 4px;
    @include themify($themes) {
        background-color: themed("main-secondary");
    }

    .option {
      transition: background-color 0.25s ease-in-out;
      background-color: transparent;
      cursor: pointer;
      margin: 0px 8px;
      padding: 2px 4px;
      border-radius: 8px;
      &.selected {
        @include themify($themes) {
          background-color: themed("neutral-tertiary");
        }
      }
      &:hover {
        @include themify($themes) {
          background-color: themed("neutral-secondary");
        }
      }
    }
  }
}

.searchBar {
  height: 50px;

  input {
    border: none;
    border-bottom: solid 1px;
  }
  input:focus {
    outline: none;
  }
}

.noResults {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 50px;
  font-size: 14px;
  text-align: center;
  
  @include themify($themes) {
    color: themed("neutral-primary");
  }
}
